import React from "react";
import { Container } from "./styles/questionSection";

export default function QuestionSection({children,...props}){
    return <Container {...props}>{children}</Container>
}